import { ButtonBase } from "@mui/material";
import { format } from "date-fns";
import { useMemo, useCallback } from "react";
import { TimeSlot } from "src/api/types";

interface Props1 {
  timeSlot: TimeSlot;
  currentValue: TimeSlot | null;
  onChange: (t: TimeSlot) => void;
}

const TimeSlotView = ({ timeSlot, currentValue, onChange }: Props1) => {
  const selected = useMemo(
    () => currentValue?.start_at === timeSlot.start_at,
    [currentValue?.start_at, timeSlot.start_at],
  );

  const handleTime = useCallback(() => {
    onChange(timeSlot);
  }, [onChange, timeSlot]);

  const formatTime = format(new Date(timeSlot.start_at), "H:mm");

  return (
    <ButtonBase
      onClick={handleTime}
      sx={{
        py: 1.25,
        borderRadius: 2,
        border: 1,
        borderColor: selected ? "primary.main" : "divider",
        bgcolor: selected ? "primary.main" : "transparent",
        color: selected ? "primary.contrastText" : "text.primary",
        fontSize: 15,
        fontVariantNumeric: "tabular-nums",
        "&:hover": {
          bgcolor: selected ? "primary.dark" : "action.hover",
        },
        "&:focus-visible": {
          outline: 2,
          outlineColor: "primary.main",
        },
      }}
    >
      {formatTime}
    </ButtonBase>
  );
};

export default TimeSlotView;
